import pluralize from 'pluralize';

export default function str_plural(string: string): string {
    return pluralize.plural(string);
}
